'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoBug = function IoBug(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.8 9.9c-0.5 1.3-1.3 2.4-2.2 3.4-1.9 1.9-4.4 2.9-7.1 2.9s-5.2-1-7.1-2.9c-0.9-1-1.7-2.1-2.2-3.4 2.3-3 5.6-4.9 9.3-4.9s7 1.9 9.3 4.9z m-19.4 1.3c1.7 3.5 5.3 6 9.5 6.2v17.6c-3.1-0.2-6-1.7-8.1-4.2-0.6 0.5-0.8 0.7-1.1 1.2 0.7 0.7 0.6 1.7 0 2.4-0.7 0.8-1.9 0.8-2.7 0.1s-0.9-1.8-0.2-2.6l0.3-0.3 0.1 0c0.3-1.1 1.1-2 2.1-2.8-1.1-2.1-2-4.5-2.2-7.1-0.6 0-1 0.2-1.4 0.3 0 1-0.8 1.8-1.8 1.8s-1.9-0.9-1.9-1.9 0.9-1.9 1.9-1.9h0.2c0.3-0.2 0.6-0.4 0.9-0.5 0.6-0.1 1.1-0.3 2-0.3 0.1-1.8 0.5-3.5 1-5.1-0.5-0.3-0.8-0.5-1.2-0.8-0.4-0.4-0.8-1-1.1-1.5 0 0-0.2-0.1-0.3-0.2-0.9-0.4-1.1-1.6-0.7-2.5s1.7-1.2 2.6-0.7c0.9 0.4 1.2 1.5 0.8 2.4 0.1 0.2 0.2 0.5 0.3 0.6 0.2 0.2 0.4 0.2 0.6 0.4 0.2-0.2 0.3-0.4 0.4-0.6z m25.7 8.8c1 0 1.9 0.9 1.9 1.9s-0.9 1.9-1.9 1.9-1.8-0.8-1.8-1.8c-0.4-0.1-0.8-0.3-1.4-0.3-0.2 2.6-1.1 5-2.2 7 1.1 0.9 1.8 1.8 2.1 2.9 0 0 0 0 0.1 0l0.3 0.3c0.7 0.8 0.6 1.9-0.2 2.6s-2 0.7-2.7-0.1c-0.6-0.7-0.7-1.7 0-2.4-0.3-0.5-0.5-0.7-1.1-1.2-2.1 2.5-5 4-8.1 4.2v-17.6c4.2-0.2 7.8-2.7 9.5-6.2 0.1 0.2 0.2 0.4 0.4 0.6 0.2-0.2 0.4-0.2 0.6-0.4 0.1-0.1 0.1-0.4 0.3-0.6-0.4-0.9-0.1-2 0.8-2.4 0.9-0.5 2.1-0.3 2.6 0.7s0.2 2.1-0.7 2.5c-0.1 0.1-0.3 0.2-0.4 0.2-0.2 0.5-0.6 1.1-1 1.5-0.4 0.3-0.7 0.5-1.2 0.8 0.5 1.6 0.9 3.3 1 5.1 0.9 0 1.4 0.2 1.9 0.3 0.4 0.1 0.7 0.3 1 0.5h0.2z' })
        )
    );
};

exports.default = IoBug;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/bug.js
// module id = 2453
// module chunks = 168707334958949